<template>
  <img
    :src="thumbnailUrl"
    :alt="alt"
    :width="width"
    :height="height"
    class="profile-image"
  />
</template>

<script setup>
  import { resizeThumbnail } from '@/common/utils/image'
  import { computed } from 'vue'
  import { useStore } from '@/common/utils/store'

  const store = useStore()

  const props = defineProps({
    imageUrl: {
      type: String,
    },
    width: {
      type: [Number, String],
      default: 22,
    },
    height: {
      type: [Number, String],
      default: 22,
    },
    alt: {
      type: String,
    },
  })

  const thumbnailUrl = computed(() => {
    return resizeThumbnail(image.value.url, {
      width: 0,
      height: 0,
      option: 20,
      quality: 80,
    })
  })

  const image = computed(() => {
    return {
      url:
        props.imageUrl ||
        store.getters.csInfo.profileimage ||
        'img.wavve.com/service30/profile/0.png',
      alt: props.alt || store.getters.csInfo.alt || '프로필 이미지',
    }
  })
</script>
